import Error from "./Error";
import ModelError from "./ModelError";

export default {
  Error,
  ModelError
};



// WEBPACK FOOTER //
// ./src/Core/Components/Alerts/index.js